import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isProfile: false,
    show: false,
    goals: [],
    isDisabled: false,
  },
  mutations: {
    addGoal(state, obj) {
      if (state.goals[obj.index]["newItem"].trim() === "") {
        alert("The field is empty!");
      } else {
        state.goals[obj.index]["items"].push(state.goals[obj.index]["newItem"]);
        state.goals[obj.index]["newItem"] = "";
      }
    },
    setHeaderName(state, obj) {
      if (state.goals[obj.index].name.trim() === "") {
        alert("The field is empty!");
      } else {
        state.goals[obj.index].isHeader = true;
        state.isDisabled = false;
      }
    },
    completed(state, obj) {
      state.goals[obj.index]["items"].splice(obj.index2, 1);
    },
    removeCard(state, obj) {
      state.goals.splice(obj.index, 1);
      state.isVisible = false;
    },
    addNewCard(state) {
      state.goals.push({ name: "", items: [], newItem: "", isHeader: false });
      state.isDisabled = true;
    },
  },
  actions: {},
  modules: {},
});
